export default "__VITE_ASSET__$cpsfxtY__"